import React from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../ScrollParallax";

// Liste des 12 OPCO avec leurs logos
const opcoItems = [
  {
    name: "AFDAS",
    logo: "/images/opco/afdas.svg",
    color: "#E8F4FD"
  },
  {
    name: "AKTO",
    logo: "/images/opco/akto.svg",
    color: "#E8F4FD"
  },
  {
    name: "ATLAS",
    logo: "/images/opco/atlas.svg",
    color: "#E8F4FD"
  },
  {
    name: "Constructys",
    logo: "/images/opco/constructys.svg",
    color: "#E8F4FD"
  },
  {
    name: "OCAPIAT",
    logo: "/images/opco/ocapiat.svg",
    color: "#E8F4FD"
  },
  {
    name: "OPCO 2i",
    logo: "/images/opco/opco2i.svg",
    color: "#E8F4FD"
  },
  {
    name: "OPCOMMERCE",
    logo: "/images/opco/opcommerce.svg",
    color: "#E8F4FD"
  },
  {
    name: "OPCO EP",
    logo: "/images/opco/opcoep.svg",
    color: "#E8F4FD"
  },
  {
    name: "OPCO Mobilités",
    logo: "/images/opco/opcomobilites.svg",
    color: "#E8F4FD"
  },
  {
    name: "OPCO Santé",
    logo: "/images/opco/opcosante.svg",
    color: "#E8F4FD"
  },
  {
    name: "Uniformation",
    logo: "/images/opco/uniformation.svg",
    color: "#E8F4FD"
  },
];

const Workouts = () => {
  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          <div className={styles.textContent}>
            <h2 className={cn("h2", styles.title)}>
              Interconnexion native avec les OPCO
            </h2>
            <div className={styles.info}>
              Notre architecture technique garantit une compatibilité totale avec les systèmes d'information de tous les organismes paritaires collecteurs agréés. Transmission instantanée et sécurisée de vos dossiers via des API certifiées.
            </div>
          </div>
          <div className={styles.opcoGrid}>
            {opcoItems.map((opco, index) => (
              <ScrollParallax key={index} className={styles.opcoCard}>
                <div 
                  className={styles.opcoItem}
                  style={{ backgroundColor: opco.color }}
                >
                  <img 
                    src={opco.logo} 
                    alt={opco.name}
                    className={styles.opcoLogo}
                  />
                </div>
              </ScrollParallax>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Workouts;
